import { Body } from '@highlight-ui/typography';
import classnames from 'classnames';
import React from 'react';
import { searchSubstring } from '../../../helpers';
import { SelectOption, SelectOptionLabelProps } from '../../../types';
import styles from './MultiLineOptionLabel.module.scss';
import SingleLineOptionLabel from './SingleLineOptionLabel';

function MultiLineOptionLabel<T extends SelectOption>({
  option,
  highlightedText,
  selected,
  disabled,
  truncateText = false,
  enableSubLabelSearch = false,
}: SelectOptionLabelProps<T> & { truncateText?: boolean }) {
  const startIndex = searchSubstring(option.subLabel, highlightedText);
  const endIndex = startIndex + highlightedText.length;

  return (
    <>
      <span className={styles.label}>
        <SingleLineOptionLabel
          highlightedText={highlightedText}
          option={option}
          selected={selected}
          disabled={disabled}
        />
      </span>

      {option.subLabel ? (
        <span
          title={option.subLabel}
          className={classnames(styles.subLabel, {
            [styles.disabled]: option.disabled,
          })}
        >
          <Body
            as="p"
            color={
              disabled || option.disabled ? 'text-disabled' : 'text-subdued'
            }
            truncate={truncateText}
          >
            {!enableSubLabelSearch || startIndex === -1 ? (
              option.subLabel
            ) : (
              <>
                {option.subLabel.substring(0, startIndex)}
                <b>{option.subLabel.substring(startIndex, endIndex)}</b>
                {option.subLabel.substring(endIndex)}
              </>
            )}
          </Body>
        </span>
      ) : null}
    </>
  );
}

export default MultiLineOptionLabel;
